import { objectWithRandomUniqueKey } from '../../common/utils/randomUniqueKey';
import type {
  CategoryValidFormDataType,
  CategoryRelationValidFormDataType,
  ClassifierValidFormDataType,
} from './validFormData/types';

export const defaultCategoryFormData: CategoryValidFormDataType =
  objectWithRandomUniqueKey({
    id: null,
    code: '',
    name: '',
    nameEng: '',
    description: '',
    categoryType: '',
    sequenceNumber: '' as any,
    validPeriod: [null, null],
    inUse: false,
    categoryRelations: [],
    parentKey: null,
    levelNumber: 1,
    childSequenceNumber: 0,
  });

export const defaultCategoryRelationFormData: CategoryRelationValidFormDataType =
  {
    id: null,
    subCategory: '',
    subCategoryType: '',
    sequenceNumber: '' as any,
    validPeriod: [null, null],
  };

export const defaultClassifierFormData: ClassifierValidFormDataType = {
  id: null,
  code: '',
  name: '',
  description: '',
  validPeriod: [null, null],
  hasCategories: true,
  codeFormat: '',
  dataTypeId: null,
  categories: [],
  categoryGroups: [],
  combinedGroups: [],
  hierarchy: [],
};
